import {SportType} from './SportType';
import {Track} from './Track';
import {Category} from './Category';
import {StartFee} from './StartFee';
import {FioConfig} from './FioConfig';

export class Race {
  id;
  name;
  dateStart;
  dateFinish;
  dateOfReg;
  regOfMessage;
  sportType: SportType | string | any;
  track: Track[];
  defaultCat;
  categories: Category[];
  web;
  location;
  sameDate;
  organizer;
  emailOr;
  mobileOr;
  detail;
  startFee: StartFee[] = [];
  fioConfig = undefined;
  rulesUrl: string;
  gdprPlaceholder: string;
}
